import { Component, Output, EventEmitter, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'apc-datatable-filters',
  templateUrl: './filters.component.html',
  styleUrls: ['./filters.component.scss', '../datatable.component.scss']
})
export class FiltersComponent {
  @Output() displaySearchEvent = new EventEmitter<boolean>();
  @Output() clearSearchEvent = new EventEmitter<boolean>();
  @Output() exportCSVEvent = new EventEmitter<boolean>();
  @Output() refreshDataEvent = new EventEmitter<boolean>();
  @Output() selectTableColumnsEvent = new EventEmitter<boolean>();
  @Output() selectAllColumnsEvent = new EventEmitter<boolean>();
  @Output() unselectAllColumnsEvent = new EventEmitter<boolean>();

  @Input() columnsToDisplayInDropdown: any = [];
  @Input() showSearch:boolean = false;
  @Input() enableFilter:boolean = false;
  @Input() selectedTableColumns: any = [];
  @Input() selectedRows:any[] = [];
  @Input() section: string = "";
 
  
  public columnFilter:boolean = false;

  constructor(public translate: TranslateService) { }

  getLabelClass(labelKey) {
    let labelLength = 0;
    if(this.translate != null && typeof this.translate != typeof undefined){
      if(this.translate.instant(labelKey) != null && typeof this.translate.instant(labelKey) != typeof undefined){
        labelLength = this.translate.instant(labelKey).length;
      }
    }
    
    let labelClass = "label-";

    if (labelLength < 5)
      labelClass += 'xs';
    else if (labelLength >= 5 && labelLength < 10)
      labelClass += 'sm';
    else if (labelLength >= 10 && labelLength < 15)
      labelClass += 'md';
    else if (labelLength >= 15 && labelLength < 30)
      labelClass += 'lg';
    else labelClass += 'xl';

    return labelClass;
  }

  onClickedOutside(e: any) {
    if (typeof e.target.className === 'string') {
      if (
        !e.target.parentElement?.className.includes('select-utils') &&
        e.target.tagName.toLocaleLowerCase() !== 'input' &&
        !e.target.className.includes('ng-option') &&
        !e.target.className.includes('dropdown-select-label') &&
        !e.target.className.includes('dropdown-select-wrapper')
      )
        this.columnFilter = false;
    }
  }

}
